/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext, useEffect, useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex } from '@getgo/chameleon-chakra-ui';

import { SessionContext } from '../../../context/SessionContext';
import { navigateFromWindowTo } from '../../../services/NavigatorService';
import { buildGoToOpenerJoinUrl } from '../../../services/UrlService';
import { GoToJoinOngoing } from '../../GoTo/Ongoing/GoToJoinOngoing';

interface Props {
  onTryAgain: () => void;
  onLaunchedSuccessfully: () => void;
  onHandlerNotRegistered: () => void;
}

const messages = defineMessages({
  heading: {
    id: 'secondJoin.heading',
  },
});

export const GoToSecondJoinAutomatic: React.FC<Props> = (props) => {
  const { onLaunchedSuccessfully, onHandlerNotRegistered } = props;
  const { formatMessage: f } = useIntl();
  const { openerLaunchToken } = useContext(SessionContext);
  const openerJoinUrl = buildGoToOpenerJoinUrl(openerLaunchToken);
  // @ts-ignore navigator.msLaunchUri is needed for IE, but removed in typescript@4.4.x
  const msLaunchUriExists = navigator.msLaunchUri !== undefined;
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // @ts-ignore navigator.msLaunchUri is needed for IE, but removed in typescript@4.4.x
    navigator.msLaunchUri?.(
      openerJoinUrl,
      onLaunchedSuccessfully,
      onHandlerNotRegistered
    );
    if (ref.current?.contentWindow) {
      navigateFromWindowTo(ref.current.contentWindow, openerJoinUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex direction='column' justifyContent='center'>
      <GoToJoinOngoing onTryAgain={props.onTryAgain} />
      {!msLaunchUriExists && <iframe ref={ref} title={f(messages.heading)} />}
    </Flex>
  );
};
